import React from "react";
import { removeShopifyIdPath } from "../../../shared/analytics";
import { useSeoMetadata } from "../../../shared/hooks/useSeoMetadata";
import { AggregateRatingInfo, shopifyProductToJsonLd } from "../../../shared/models/structuredData";
import SeoHead from "../../head";
import { ProductInfoSharedPageProps } from "../page";

export const ProductHead = ({ storeReviewRating, reviewList, storeReviewCount, product, location, shopifyAdmin, storefrontProduct }: ProductInfoSharedPageProps) => {
    const seoMetadata = useSeoMetadata();
    const {
        title,
        description,
        // seo1x1Image,
        // seo16x9Image,
        // seo4x3Image,
        media
    } = product

    const shopifyAdminProduct = shopifyAdmin.products.nodes[0];
    const metafields = shopifyAdminProduct.metafields;
    const seoDescription = metafields.nodes?.find(metafield => metafield.key == 'description_tag')?.value || description;

    const storeReview: AggregateRatingInfo | undefined = storeReviewRating?.all_reviews_rating && storeReviewCount?.all_reviews_count ? {
        reviewCount: storeReviewCount.all_reviews_count,
        ratingValue: storeReviewRating.all_reviews_rating
    } : undefined

    // const jsonLdImages = [];
    // if (seo1x1Image) {
    //     jsonLdImages.push(shopifyImageToJsonLd(seo1x1Image.preview.image));
    // }
    // if (seo16x9Image) {
    //     jsonLdImages.push(shopifyImageToJsonLd(seo16x9Image.preview.image));
    // }
    // if (seo4x3Image) {
    //     jsonLdImages.push(shopifyImageToJsonLd(seo4x3Image.preview.image));
    // }

    // let metaImageUrl: string | null = null;
    // console.log('heree Head0', jsonLdImages, media)

    // if (jsonLdImages.length === 0 && media && media.length > 0) {
    //     const img: any = media[indexOfFirstProductImage];
    //     const gatsbyImg = getImage((img as any).image.localFile.childImageSharp.original);

    //     // console.log('heree Head', media, gatsbyImg)

    //     if (gatsbyImg) {
    //         const url = getSrc(gatsbyImg);
    //         if (url) {
    //             metaImageUrl = url;
    //             jsonLdImages.push(shopifyImageToJsonLd({
    //                 url: url,
    //                 height: gatsbyImg.height,
    //                 width: gatsbyImg.width
    //             }));
    //         }
    //     }
    // }

    const shopifyProductIdNumber = removeShopifyIdPath(product.shopifyId);

    // let currentDate = new Date();
    // currentDate.setHours(0, 0, 0, 0);
    // currentDate.setDate(currentDate.getDate() + 14);

    // console.log('heree head', location)

    // const defaultVariant = last(product.variants);
    // const selectedVariant = variantId ? product.variants.find(v => v.shopifyId === variantId) : defaultVariant


    // console.log('heree', serverData)
    //   "image": "https://${location.origin}${((firstImage as any).getSrc(image.thumbnail).childImageSharp.gatsbyImageData as IGatsbyImageData).images.fallback.src}",

    return (
        <SeoHead
            title={'Shop ' + title}
            description={seoDescription}
            pathname={location.pathname}
        // image={{ url: metaImageUrl || jsonLdImages[0]["url"] }}
        >
            {/* <link
        rel="preload"
        as="image"
        href={getSrc((media as any)[0].image.localFile.childImageSharp.original)}
        imageSrcSet={getSrcSet((media as any)[0].image.localFile.childImageSharp.original)}
      /> */}
            <script type="application/ld+json" key={`product_${shopifyProductIdNumber}`} id={`product_${shopifyProductIdNumber}`}>
                {
                    shopifyProductToJsonLd(product, storefrontProduct, shopifyAdmin, seoMetadata.site.siteUrl, storeReview, reviewList?.nodes)
                }
            </script>
        </SeoHead>
    )
};